// Utility functions for language management

// Available languages based on translation files
export const AVAILABLE_LANGUAGES = {
  'en': {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸'
  },
  'de': {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    flag: '🇩🇪'
  },
  'fr': {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    flag: '🇫🇷'
  },
  'es': {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸'
  }
};

// Get available language codes
export const getAvailableLanguageCodes = () => {
  return Object.keys(AVAILABLE_LANGUAGES);
};

// Get language info by code
export const getLanguageInfo = (code) => {
  return AVAILABLE_LANGUAGES[code] || null;
};

// Get all available languages
export const getAvailableLanguages = () => {
  return Object.values(AVAILABLE_LANGUAGES);
};

// Check if a language code is supported
export const isLanguageSupported = (code) => {
  return code in AVAILABLE_LANGUAGES;
};

// Get current language from localStorage or default to 'en'
export const getCurrentLanguage = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('preferredLanguage') || 'en';
  }
  return 'en';
};

// Set current language in localStorage
export const setCurrentLanguage = (languageCode) => {
  if (typeof window !== 'undefined' && isLanguageSupported(languageCode)) {
    localStorage.setItem('preferredLanguage', languageCode);
    return true;
  }
  return false;
};

// Note: This function is deprecated in favor of the language context
// The language context handles language changes dynamically without page reload
export const changeLanguage = (languageCode) => {
  console.warn('changeLanguage from languageUtils is deprecated. Use the language context instead.');
  return setCurrentLanguage(languageCode);
}; 